import React, { lazy, Suspense } from 'react';
import { render } from 'react-dom';
import { parseDatasetToProps } from "../../parseDatasetToProps";

const ProductQuestionWizard = lazy(() => import(/* webpackChunkName: "ProductQuestionWizard" */ './components/ProductQuestionWizard'));

const productQuestionWizard = document.getElementById('product-question-wizard');
if (productQuestionWizard != null) {
    const props = parseDatasetToProps(productQuestionWizard.dataset);

    render(
        <Suspense fallback={<></>}>
            <ProductQuestionWizard
                {...props}
            />
        </Suspense>,
        productQuestionWizard
    );
}
